export default {
  title: "My profile",
  saved: "Profile saved",
  account: {
    title: "Account",
    fullName: "Full name",
    username: "Username",
    role: "Role",
    branch: "Branch",
    manager: "Manager",
    memberSince: "Member since",
    managed: "Managed by your manager. Ask them to change it.",
  },
  timezone: {
    title: "Time zone",
    myTime: "My time",
    branchHint: "Branch time zone: {{tz}}",
    driverTimes: "Driver times are shown in the driver's state time + yours.",
  },
  notifications: {
    title: "Notifications",
    inApp: "In-app notifications",
    telegram: "Telegram",
    telegramHint: "Coming in a later stage",
  },
  password: {
    title: "Change password",
    current: "Current password",
    new: "New password",
    confirm: "Confirm new password",
    mismatch: "Passwords do not match",
    hint: "At least 10 characters. Not the same as your old password.",
    update: "Update password",
    updated: "Password updated",
    failed: "Could not change password",
  },
  twofa: {
    title: "Two-factor authentication",
    requiredRole: "Required for your role",
    disable: "Disable",
    enable: "Enable 2FA",
    ownerAdvice: "We recommend 2FA for the owner account: it protects the whole company.",
    intro: "Protect your account with a 6-digit code from an authenticator app (Google Authenticator, Authy, 1Password).",
    step1: "1. Scan this QR code with an authenticator app.",
    manual: "Can't scan? Enter this key manually:",
    step2: "2. Enter the 6-digit code from the app.",
    backupHint: "After enabling you will get 10 backup codes. They are shown only once.",
    backupTitle: "Backup codes — save them now, they are shown only once.",
    savedThem: "I saved them",
    enabledText: "Enabled. You will be asked for a code at every sign-in.",
    newPhone: "New phone? Turn 2FA off and set it up again.",
    newPhoneAskOwner: "New phone? Ask the owner to reset your 2FA (Admin → Users), then set it up again.",
    newPhoneOwner: "New phone? Untick “Owner” in Settings → Security, turn 2FA off and set it up again.",
    enabledToast: "Two-factor authentication enabled",
    disabledToast: "Two-factor authentication disabled",
    enableFailed: "Could not enable 2FA",
    disableFailed: "Could not disable 2FA",
    disableTitle: "Disable two-factor authentication",
    disableDesc: "Confirm with your password.",
    password: "Password",
    qrAlt: "QR code",
  },
};
